/* eslint-disable no-case-declarations */
import _ from 'lodash';
import {
  FETCH_EPG_CHANNEL_ERROR,
  FETCH_EPG_CHANNEL_INIT,
  FETCH_EPG_CHANNEL_SUCCESS,
} from '../actions/channel/constants';

const initialState = {
  loading: null,
  data: {},
  error: null,
};

const customizer = (objValue, srcValue) => {
  if (_.isArray(objValue)) {
    if (objValue[objValue.length - 1].id === srcValue[0].id) srcValue.shift();
    return objValue.concat(srcValue);
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EPG_CHANNEL_INIT:
      return { ...state, loading: true, error: null, data: {} };
    case FETCH_EPG_CHANNEL_SUCCESS:
      let info;
      let payload = {};
      const nodeState = state.data[action.nodeId];

      if (nodeState) {
        info = {
          events: _.mergeWith(nodeState.events, action.data, customizer),
          counter: action.counter,
        };
      } else {
        info = {
          events: action.data,
          counter: 1,
        };
      }

      if (!_.isEmpty(state.data)) {
        const newData = Object.assign(state.data);
        payload = { ...newData, [action.nodeId]: info };
      } else {
        payload = {
          [action.nodeId]: info,
        };
      }

      return { ...state, loading: false, data: payload, error: null };
    case FETCH_EPG_CHANNEL_ERROR:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};
